module.exports = __webpack_public_path__ + "static/media/certificate.ba738fe0.svg";